import {
  COLLAPSIBLE_HEADER_CONTENT_TOP_PADDING,
  CollapsibleScreenHeader,
} from "@/components/prooftree/CollapsibleScreenHeader"
import { Box } from "@/components/ui/box"
import { HStack } from "@/components/ui/hstack"
import { Text } from "@/components/ui/text"
import { VStack } from "@/components/ui/vstack"
import { Colors } from "@/constants/Colors"
import { useLocalSearchParams } from "expo-router"
import { CreditCard, Lock } from "lucide-react-native"
import { useRef } from "react"
import { Animated, Platform } from "react-native"
import { SafeAreaView } from "react-native-safe-area-context"

export default function PaymentScreen() {
  const params = useLocalSearchParams()
  const itemTitle = (params.title as string) || "Premium Content"
  const itemPrice = (params.price as string) || "2.00"
  const itemType = (params.type as string) || "Content"
  const scrollY = useRef(new Animated.Value(0)).current

  return (
    <SafeAreaView
      className="flex-1"
      edges={["top", "bottom"]}
      style={{ backgroundColor: Colors.dark.surface }}
    >
      <CollapsibleScreenHeader
        scrollY={scrollY}
        eyebrow="Payment Guardrail"
        title="Payments unavailable"
        subtitle="No production billing provider is implemented in this repo."
        accentColor={Colors.dark.proof}
        backFallbackHref="/"
        statusText={`$${itemPrice}`}
      />
      <Animated.ScrollView
        className="flex-1"
        contentContainerStyle={{
          padding: 24,
          paddingTop: COLLAPSIBLE_HEADER_CONTENT_TOP_PADDING,
          paddingBottom: Platform.OS === "web" ? 64 : 48,
        }}
        showsVerticalScrollIndicator={false}
        scrollEventThrottle={16}
        onScroll={Animated.event([{ nativeEvent: { contentOffset: { y: scrollY } } }], {
          useNativeDriver: false,
        })}
      >
        <Box
          className="rounded-3xl border p-5"
          style={{
            backgroundColor: Colors.dark.surfaceSecondary,
            borderColor: `${Colors.dark.proof}55`,
          }}
        >
          <VStack className="gap-5">
            <HStack className="items-center gap-3">
              <Box
                className="h-12 w-12 items-center justify-center rounded-2xl"
                style={{ backgroundColor: `${Colors.dark.proof}24` }}
              >
                <CreditCard color={Colors.dark.proof} size={22} />
              </Box>
              <VStack className="flex-1">
                <Text className="text-2xl font-bold text-white">Payments unavailable</Text>
                <Text className="text-sm leading-5" style={{ color: Colors.dark.textSecondary }}>
                  No production billing provider is implemented in this repo.
                </Text>
              </VStack>
            </HStack>

            <Box
              className="rounded-2xl border p-4"
              style={{
                backgroundColor: Colors.dark.surface,
                borderColor: "rgba(255,255,255,0.08)",
              }}
            >
              <Text className="text-sm font-bold" style={{ color: Colors.dark.textSecondary }}>
                Requested item
              </Text>
              <Text className="mt-1 text-xl font-bold text-white">{itemTitle}</Text>
              <Text className="mt-1 text-sm" style={{ color: Colors.dark.textSecondary }}>
                {itemType} / ${itemPrice}
              </Text>
            </Box>

            <HStack className="items-start gap-3">
              <Lock color={Colors.dark.textSecondary} size={18} />
              <Text
                className="flex-1 text-sm leading-5"
                style={{ color: Colors.dark.textSecondary }}
              >
                The previous mock checkout has been disabled to avoid silent fake payment behavior.
                Add a real billing provider and update the Supabase/docs surface before enabling
                purchases.
              </Text>
            </HStack>
          </VStack>
        </Box>
      </Animated.ScrollView>
    </SafeAreaView>
  )
}
